export default "__VITE_ASSET__CeiaKFde__"